// src/features/student-management/ui/organisms/PersonForm/personFormConfig.ts

export type StepKey =
  | 'personal'
  | 'contact'
  | 'professional'
  | 'documents'
  | 'addresses'
  | 'profiles'
  | 'financial'
  | 'roles';

export const BASE_STEP_KEYS: readonly StepKey[] = [
  'personal',
  'contact',
  'professional',
  'addresses',
  'profiles',
  'financial',
] as const;

/** Em modo edição as abas de documentos e vínculos ficam disponíveis pois dependem do ID da pessoa */
export const EDIT_STEP_KEYS: readonly StepKey[] = [
  ...BASE_STEP_KEYS,
  'documents',
  'roles',
] as const;

/** Mapeia cada campo do form para a etapa que o contém — usado no resumo de validação */
export const FIELD_TO_STEP: Record<string, StepKey> = {
  firstName: 'personal',
  lastName: 'personal',
  alias: 'personal',
  email: 'personal',
  cpf: 'personal',
  birthDate: 'personal',
  gender: 'personal',
  martialStatus: 'personal',
  mothersName: 'personal',
  fathersName: 'personal',
  spouseName: 'personal',
  rg: 'personal',
  dispatcherOrgan: 'personal',
  dispatcherOrganState: 'personal',
  dateDispatch: 'personal',
  passportNumber: 'personal',
  idCountryNumber: 'personal',
  isPCD: 'personal',
  pcdDescription: 'personal',
  useAccessibilityTool: 'personal',
  accessibilityToolDescription: 'personal',
  celPhone: 'contact',
  homePhone: 'contact',
  workPhone: 'contact',
  urlLinkedin: 'contact',
  urlLattes: 'contact',
  receiveSms: 'contact',
  receiveMarketing: 'contact',
  miniCurriculum: 'contact',
  observation: 'contact',
  profession: 'professional',
  company: 'professional',
  otherJobPosition: 'professional',
  otherBusinessSector: 'professional',
  serviceTime: 'professional',
  experienceLevel: 'professional',
  selfEmployed: 'professional',
  isWorking: 'professional',
  academicEducation: 'professional',
  academicCourseName: 'professional',
  completionDate: 'professional',
  personalAddress: 'addresses',
  paymentAddress: 'addresses',
  isStudent: 'profiles',
  isMonitor: 'profiles',
  isEmployee: 'profiles',
  isTeachingStaff: 'profiles',
  student: 'profiles',
  employee: 'profiles',
  teachingStaff: 'profiles',
  financialBankName: 'financial',
  financialAgency: 'financial',
  financialCheckingAccount: 'financial',
  financialSavingAccount: 'financial',
  financialPaymentMethod: 'financial',
  financialAccountType: 'financial',
};

/** Mapeia cada etapa para os campos do form que ela contém — usado na validação por step */
export const STEP_TO_FIELDS = Object.entries(FIELD_TO_STEP).reduce<Record<StepKey, Array<string>>>(
  (acc, [field, step]) => {
    acc[step].push(field);
    return acc;
  },
  {
    personal: [],
    contact: [],
    professional: [],
    documents: [],
    addresses: [],
    profiles: [],
    financial: [],
    roles: [],
  },
);
